import { render, staticRenderFns } from "./Regional.vue?vue&type=template&id=41491c9d&scoped=true&"
import script from "./Regional.vue?vue&type=script&lang=js&"
export * from "./Regional.vue?vue&type=script&lang=js&"
import style0 from "./Regional.vue?vue&type=style&index=0&id=41491c9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41491c9d",
  null
  
)

export default component.exports